import { memo } from "react";

import { ErrorSpan } from "@/components/ErrorSpan";
import { FuzzyDuration } from "@/components/FuzzyDuration";
import { Item } from "../queries/tracking-data/items";

export interface LeadTimeCellProps {
  item: Item;
  fuzzyDurationThreshold?: number;
}

const LeadTimeCellInternal: React.FC<LeadTimeCellProps> = ({ item, fuzzyDurationThreshold }) => {
  // Render nothing if the lead time is not set
  const leadTimeMs = item.leadTimeMs;
  if (!leadTimeMs) return null;

  // Conditionally render an alert icon if the lead time is greater than 3 weeks (21 days)
  const leadTimeDays = Math.ceil(item.leadTimeDays!);
  const showAlert = !!leadTimeDays && leadTimeDays >= 21;

  return (
    <ErrorSpan error={showAlert}>
      {leadTimeDays.toFixed(0)} days{" "}
      {fuzzyDurationThreshold && leadTimeDays > fuzzyDurationThreshold && (
        <>
          (~
          <FuzzyDuration duration={leadTimeMs} />)
        </>
      )}
      {showAlert && <span className="align-text-bottom text-warning">⚠</span>}
    </ErrorSpan>
  );
};

export const LeadTimeCell = memo(LeadTimeCellInternal);
